var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27148 3.99999C9.10555 3.99531 8.94275 4.04579 8.80859 4.14355L3.30859 8.14355C3.21299 8.21315 3.1352 8.30437 3.08157 8.40977C3.02794 8.51516 2.99999 8.63174 3 8.74999V19.25C3.00001 19.3884 3.0383 19.524 3.11062 19.642C3.18295 19.76 3.2865 19.8556 3.40982 19.9184C3.53313 19.9812 3.67141 20.0086 3.80935 19.9977C3.94729 19.9867 4.07952 19.9379 4.19141 19.8564L9.25 16.1777L14.3027 19.8564C14.431 19.9498 14.5855 20.0001 14.7441 20.0001C14.9028 20.0001 15.0573 19.9498 15.1855 19.8564L20.6904 15.8564C20.7862 15.7869 20.8642 15.6958 20.918 15.5904C20.9718 15.485 20.9999 15.3683 21 15.25V4.74999C20.9999 4.61178 20.9615 4.4763 20.8893 4.35849C20.817 4.24069 20.7136 4.14515 20.5904 4.08241C20.4673 4.01967 20.3292 3.99218 20.1914 4.00297C20.0536 4.01376 19.9215 4.06241 19.8096 4.14355L14.7451 7.82226L9.69141 4.14355C9.56912 4.05444 9.42273 4.00439 9.27148 3.99999ZM19.5 6.22167V14.8682L15.5 17.7734V9.12792L19.5 6.22167ZM8.5 6.22265V14.8682L4.5 17.7773V9.13183L8.5 6.22265ZM10 6.22363L14 9.13574V17.7803L10 14.8682V6.22363Z",
    fill: "#F70763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.da344e1dbea9b5b6cb04cd57bf012922.svg";
export { ForwardRef as ReactComponent };